import $fn from '@/utils/fn';
export default {
	namespaced: true,
	state: {
        active: 1,
        type: "purchaser"
	},
	mutations: {
	},
	actions: {
	},
}
